/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/


import colors from "./colors";
import {
  AGENT_TOKEN_COOKIE_KEY,
  AGENT_INFO_COOKIE_KEY
} from "./cookie";
import teamMembers from "./teamMembers";
import onboardingQuestions from "./partnerOnboarding";
import partnerWebinarQuestions from "./partnerWebinar";
import successStories from "./successStories";
import pwpSuccessStories from "./pwpSuccessStories";
import indianCityList from "./indianCityList";
import investmentExpertsStories from "./investmentExpertsStories";
import {
  schemes,
  documents
} from "./commissionDisclosures";
import {
  aboutWealthy,
  broking,
  wealthyPartner,
  mutualFunds
} from "./faqs";
import {
  TransferGuidelines,
  PaymentDepositDetails,
  BankDepositDetails
} from "./fundTransfer";
import newsletterNav from "./newsletterNav";
import newsletterTagline from "./newsletterTagline";
import publicBlogCta from "./publicBlogCta";
import {
  JAGROOK_MESSAGE,
  RISK_DISCLOSURES,
  SEBI_AWARENESS_DISPLAY
} from "./sebiInvestorAwareness";
import {
  brokingSchema,
  mfdFaqSchema,
  licFaqSchema,
  articleSchema
} from "./faqSchema";
import professionList from "./professionList";
import WealthyOfficesList from "./officeLocations";

export {
  colors,
  teamMembers,
  successStories,
  pwpSuccessStories,
  onboardingQuestions,
  partnerWebinarQuestions,
  indianCityList,
  investmentExpertsStories,

  AGENT_TOKEN_COOKIE_KEY,
  AGENT_INFO_COOKIE_KEY,

  schemes,
  documents,

  aboutWealthy,
  broking,
  wealthyPartner,
  mutualFunds,

  TransferGuidelines,
  PaymentDepositDetails,
  BankDepositDetails,
  newsletterNav,
  newsletterTagline,
  publicBlogCta,
  JAGROOK_MESSAGE,
  RISK_DISCLOSURES,
  SEBI_AWARENESS_DISPLAY,
  brokingSchema,
  mfdFaqSchema,
  licFaqSchema,
  articleSchema,
  professionList,

  WealthyOfficesList
};
